import {
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Container,
  Divider,
  Rating,
  Snackbar,
  Stack,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Review from "../../review/models/IReview";
import ReviewService from "../../review/services/ReviewService";

const service = new ReviewService();

const ManageReviewApprovalPage = () => {
  const [reviews, setReviews] = useState<Review[]>([]);
  const [loadingId, setLoadingId] = useState<number | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    fetchUnapproved();
  }, []);

  const fetchUnapproved = async () => {
    const response = await service.getUnapprovedReviews();
    setReviews(response);
  };

  const handleApprove = async (id: number) => {
    setLoadingId(id);
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_API_URL}/api/reviews/${id}/approve`, {
        method: "PUT",
      });

      if (!res.ok) throw new Error("Greška pri odobravanju");

      setSuccess(true);
      setReviews((prev) => prev.filter((r) => r.id !== id));
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <Container sx={{ p: 0 }}>
      <Typography variant="h5" gutterBottom>
        Odobravanje recenzija
      </Typography>

      {reviews.length === 0 ? (
        <Typography variant="body2" color="text2.primary">
          Nema recenzija za odobravanje.
        </Typography>
      ) : (
        <Stack spacing={2}>
          {reviews.map((review) => (
            <Card key={review.id}>
              <CardContent>
                <Typography fontWeight={600}>{review.userName}</Typography>
                <Rating value={review.rating} readOnly size="small" />
                <Typography variant="body2" sx={{ mt: 0 }}>
                  {review.comment || "Bez komentara"}
                </Typography>
                <Typography variant="caption" color="text2.primary">
                  {new Date(review.dateCreated).toLocaleDateString("hr-HR")}
                </Typography>

                <Box mt={2} display="flex" justifyContent="flex-end">
                  <Button
                    variant="contained"
                    onClick={() => handleApprove(review.id)}
                    disabled={loadingId === review.id}
                  >
                    {loadingId === review.id ? (
                      <CircularProgress size={20} />
                    ) : (
                      "Odobri"
                    )}
                  </Button>
                </Box>
              </CardContent>
            </Card>
          ))}
        </Stack>
      )}

      <Snackbar
        open={success}
        autoHideDuration={3000}
        onClose={() => setSuccess(false)}
        message="Recenzija odobrena!"
      />

      <Divider sx={{ mt: 4 }} />
    </Container>
  );
};

export default ManageReviewApprovalPage;
